module.exports = __webpack_public_path__ + "static/media/lung_cancer.644f7f9e.svg";